import React, { useState, useContext } from "react";
import { useIntl } from "react-intl";
// UI
import MaterialTable from "@material-table/core";

// Table Params
import { getColumns, OPTIONS, getLocalization } from "./UserGroupParams";
import { tableIcons } from "../../TableIcons";
import TableStyle from "../../../components/TableStyle";
import apiRequest from "../../../services/apiRequest";
import { NotificationsContext } from "../../Notifications";
import Button from "../../Button";

export default function AddedUserGroupTable({ users, selectedGroup, refresh }) {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const [selectedUsers, setSelectedUsers] = useState([]);

  function onSelectionChange(rows) {
    const user_ids = rows.map((user) => user.id);
    setSelectedUsers(user_ids);
  }

  async function removeUsers() {
    await apiRequest
      .post(`/groups/users/delete/${selectedGroup}`, selectedUsers)
      .catch(() => {
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      });
    refresh();
  }

  return (
    <>
      <TableStyle>
        <MaterialTable
          columns={getColumns(intl)}
          data={users}
          icons={tableIcons}
          options={OPTIONS}
          localization={getLocalization(intl)}
          onSelectionChange={onSelectionChange}
          isLoading={users === undefined}
        />
      </TableStyle>
      <Button
        onClick={() => removeUsers()}
        styleType="empty"
        className="text-xs text-black-500 hover:text-am-500 mt-10"
      >
        Rimuovi
      </Button>
    </>
  );
}
